export default __webpack_public_path__ + "static/media/pic7.ac92ce6d.jpg";